import React from "react";
import PageHero from "../components/PageHero";
import CTABanner from "../components/CTABanner";
import { PHOTOS } from "../lib/data";

// Curated, ordered list of all real project photos with captions
const GALLERY = [
    { src: PHOTOS.lushFloweringGarden, title: "Lush Flowering Backyard Garden", category: "Landscaping", aspect: "tall" },
    { src: PHOTOS.poolPatioOutdoorLiving, title: "Pool, Patio & Outdoor Living", category: "Landscaping", aspect: "wide" },
    { src: PHOTOS.bluestonePatioDusk, title: "Bluestone Patio with Up-lighting", category: "Hardscaping", aspect: "wide" },
    { src: PHOTOS.walkwayWithConeflowers, title: "Bluestone Walkway with Coneflower Bed", category: "Landscaping", aspect: "tall" },
    { src: PHOTOS.outdoorKitchen, title: "Outdoor Kitchen & Bluestone Patio", category: "Hardscaping", aspect: "wide" },
    { src: PHOTOS.retainingWallCurved, title: "Curved Retaining Wall & Steps", category: "Hardscaping", aspect: "square" },
    { src: PHOTOS.dryCreekBed, title: "Dry Creek Bed for Drainage", category: "Water Mitigation", aspect: "tall" },
    { src: PHOTOS.cobblestoneDriveway, title: "Cobblestone Driveway", category: "Hardscaping", aspect: "tall" },
    { src: PHOTOS.frontYardArborvitae, title: "Front Yard with Arborvitae Privacy Screen", category: "Landscaping", aspect: "wide" },
    { src: PHOTOS.circularStonePatio, title: "Circular Bluestone Patio with Seat Wall", category: "Hardscaping", aspect: "square" },
    { src: PHOTOS.stoneWallHedge, title: "Stone Wall, Hedge & Lawn", category: "Landscaping", aspect: "square" },
    { src: PHOTOS.lawnPaverEdge, title: "Manicured Lawn Edge", category: "Lawn Care", aspect: "square" },
    { src: PHOTOS.project8, title: "Backyard Patio Project", category: "Hardscaping", aspect: "wide" },
];

export default function GalleryPage() {
    return (
        <div data-testid="gallery-page">
            <PageHero
                eyebrow="Gallery"
                title="Real projects. Real properties."
                sub="A working gallery of recent residential projects across the DMV — every photo is from a job we've completed."
                image={PHOTOS.lushFloweringGarden}
            />

            <section className="px-4 sm:px-8 pb-16">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                        {GALLERY.map((g, i) => {
                            const heightClass =
                                g.aspect === "tall" ? "row-span-2 aspect-[3/4]" :
                                g.aspect === "wide" ? "aspect-[4/3]" :
                                "aspect-square";
                            const colClass = g.aspect === "tall" && i % 4 === 0 ? "lg:col-span-1" : "";
                            return (
                                <figure
                                    key={i}
                                    data-testid={`gallery-item-${i}`}
                                    className={`relative overflow-hidden rounded-2xl group bg-brand-surfaceAlt ${heightClass} ${colClass}`}
                                >
                                    <img
                                        src={g.src}
                                        alt={g.title}
                                        loading="lazy"
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
                                    <figcaption className="absolute bottom-4 left-4 right-4 text-white">
                                        <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-[#D6E0CF]">{g.category}</div>
                                        <div className="font-serif text-base sm:text-lg leading-tight mt-1">{g.title}</div>
                                    </figcaption>
                                </figure>
                            );
                        })}
                    </div>
                </div>
            </section>

            <section className="px-4 sm:px-8 py-16 bg-brand-surfaceAlt">
                <div className="max-w-3xl mx-auto text-center">
                    <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold mb-4">Photography note</p>
                    <h2 className="font-serif text-3xl sm:text-4xl text-brand-primary leading-[1.1] font-medium tracking-tight">
                        Every photo on this page is a real job — taken by our crew on the property after the install was finished.
                    </h2>
                    <p className="mt-5 text-brand-textMuted">More projects added throughout the season. Follow us on Instagram for weekly updates.</p>
                </div>
            </section>

            <CTABanner
                eyebrow="Inspired?"
                title="Let's design yours next."
                primaryLabel="Start a Project"
            />
        </div>
    );
}
